import { MainMenuOption } from 'src/service/MainMenu';
import { AbstractUserRole } from 'src/service/UserPermission/AbstractUserRole';
import { ComprehensiveAssessment, Org, Player, Team } from 'src/api';

export class ComprehensiveReviewerRole extends AbstractUserRole {
  canView(option: MainMenuOption): boolean {
    const allowed = [
      MainMenuOption.team,
      MainMenuOption.player,
      MainMenuOption.event,
      MainMenuOption.assessment,
      MainMenuOption.home,
      MainMenuOption.comprehensive,
    ];
    return allowed.includes(option);
  }

   
  canViewUnion(union: Org): boolean {
    return true;
  }

   
  canViewTeam(team: Team): boolean {
    return true;
  }

   
  canViewPlayer(player: Player): boolean {
    return true;
  }

   
  canCreateComprehensiveAssessment(player: Player): boolean {
    // can create for any player
    return true;
  }

   
  canEditComprehensiveAssessment(assessment: ComprehensiveAssessment): boolean {
    // can edit any assessment
    return true;
  }

  canReviewComprehensiveAssessment(
    assessment: ComprehensiveAssessment,
  ): boolean {
    return this.canCreateComprehensiveAssessment(assessment?.player ?? {});
  }
}
